module.exports = __webpack_public_path__ + "static/artworking-2-mobile-b2a7492aaad564007878b3704f18c6f5.jpg";